if ($(".js-sidebar").length) {
	const sidebar = document.querySelector('.js-sidebar');
	const content = document.querySelector('.js-content');
	
	const floatSidebar = FloatSidebar({
		sidebar: sidebar,
		relative: content,
		topSpacing: 0,
		bottomSpacing: 10
	});
}